var map = {
	"./icon_nav_activity.svg": "a63c",
	"./icon_nav_course.svg": "2666",
	"./icon_nav_customer.svg": "2f54",
	"./icon_nav_employee.svg": "ed0d",
	"./icon_nav_feedback.svg": "69fe",
	"./icon_nav_label.svg": "059f",
	"./icon_nav_match.svg": "6e85",
	"./icon_nav_order.svg": "9c32",
	"./icon_nav_resources.svg": "30b3",
	"./icon_nav_statistics.svg": "cbf3",
	"./icon_nav_system.svg": "3751",
	"./icon_nav_venue.svg": "4a12",
	"./password.svg": "2a3d",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";